import { useEffect } from 'react';

var useSetModalId = function useSetModalId(container, modalId) {
  useEffect(function () {
    if (container && modalId) {
      container.setAttribute('data-modal-id', modalId);
    }
  }, [container, modalId]);
};

export { useSetModalId };
//# sourceMappingURL=use-set-modal-id.esm.js.map
